<!--
  Created 16.11.2025
  Proposal status component for proposal show/public page.
-->
<template>
  <div
    class="fixed right-0 top-48 z-50 flex"
    :style="'top:' + (8+(4*order)) + 'rem'"
    :title="infoOpen ? 'Click again to close' : 'Click for proposal status'"
    @click="infoOpen=!infoOpen">
    <div
      class="relative flex size-12 items-center justify-center rounded-bl-lg border border-r-0 bg-amber-50 opacity-50 shadow
        transition-opacity delay-500 duration-500 ease-in-out hover:cursor-pointer hover:opacity-100 hover:transition-none md:rounded-tl-lg"
      :class="{'w-fit':infoOpen}">
      <div
        class="flex h-9 w-full flex-row justify-center space-x-1.5 px-1 pb-1 pt-1.5"
        :class="{'px-4':infoOpen}">
        <DocumentCheckIcon
          v-if="accepted"
          alt="Check icon"
          class="size-7 shrink-0 cursor-pointer self-center rounded-sm object-cover"
          :class="isSibling ? 'text-blue-500' : 'text-green-500'" />
        <DocumentChartBarIcon
          v-else
          alt="Questionmark icon"
          class="size-7 shrink-0 cursor-pointer self-center rounded-sm object-cover text-yellow-500" />
        <template v-if="infoOpen">
          <template v-if="!isEditable">
            <span class="font-medium">Version {{ version }} (id{{ versionId }})</span>
            <span class="text-gray-300">|</span>
          </template>
          <template v-if="accepted">
            <span v-if="isSibling">
              A different version of this proposal is accepted (v{{ siblingVersion }}, id{{ siblingVersionId }}).
            </span>
            <span v-else>
              This proposal is accepted.
            </span>
          </template>
          <span v-else>
            This proposal is not yet accepted.
          </span>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup>
/* external */
import {
  ref,
} from 'vue';
import {
  DocumentCheckIcon, DocumentChartBarIcon,
} from '@heroicons/vue/24/solid';

/* *********************************************************************
 * Component declarations
 * ****************************************************************** */

defineProps({
  accepted: {
    type: Boolean,
    required: true,
    default: false,
  },
  isEditable: {
    type: Boolean,
    required: false,
    default: false,
  },
  isSibling: {
    type: Boolean,
    required: false,
    default: false,
  },
  version: {
    type: Number,
    required: false,
    default: 0,
  },
  versionId: {
    type: Number,
    required: false,
    default: 0,
  },
  siblingVersion: {
    type: Number,
    required: false,
    default: 0,
  },
  siblingVersionId: {
    type: Object,
    required: false,
    default: () => {},
  },
  order: {
    type: Number,
    required: false,
    default: 3,
  },
});

const infoOpen = ref(false);

/* *********************************************************************
 * Component functions
 * ****************************************************************** */

</script>
